import React from 'react'

import TimePicker from '../../datepicker/TimePicker'
import timeUtils from 'shared/src/time'

import { getProps } from './utils'

const Time = (props) => {

  const {
    field: {
      name,
      value,
    },
    form: {
      setFieldValue,
    },
    item,
  } = getProps(props)

  const onChange = (value) => {
    setFieldValue(name, timeUtils.getTimeNumberFromTime(timeUtils.getTimeFromDate(value)))
  }

  return (
    <TimePicker
      label={ item.title || item.id }
      value={ timeUtils.getDateFromTime(value) }
      onChange={ onChange }
    />
  )
}

export default Time